//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyCell from "@/views/components/emptyCell";

export default {
    name: "broadcast",
    components: {EmptyCell},
    data() {
        return {
            broadList: [],
            pageIndex: 1,
            pageSize: 10,
            refreshing: false,
            loading: false,
            finished: false,
            show: false,
            content: '',
            id: ''
        }
    },
    methods: {
        onRefresh() {
            this.pageIndex = 1;
            this.getOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getOrders();
        },
        getOrders() {
            // if (!localStorage.getItem('MemberId') || parseInt(localStorage.getItem('MemberId')) <= 0) {
            //     return
            // }
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            var params = {
                projectId: localStorage.getItem('Select-ProjectId'),
                status: 2,
                maxResultCount: this.pageSize,
                skipCount: (this.pageIndex - 1) * this.pageSize
            };
            abp.ajax.post('/api/services/app/Broadcasting/Search', params)
                .then(res => {
                    // console.log('items：%@', res.data.result.items);
                    var broadList = res.data.result;
                    if (this.pageIndex === 1) {
                        this.broadList = [];
                    }
                    this.broadList.push(...res.data.result.items);
                    // console.log(broadList);
                    if (this.broadList.length < this.pageSize) {
                        this.finished = true;
                    }
                    /*var broadList = res.data.result;
                    if (broadList.length > 0) {
                        //console.log(list);
                        /!*this.getGraphicInformationByBusiness(list[0].id)*!/
                        this.broadList.push(...res.data.result);
                    }*/
                })
                .catch(() => {
                })
                .then(() => {
                    this.refreshing = false;
                    this.loading = false;
                });
        },
        /*showPopup(content) {
            this.show = true;
            this.content = content;
        }*/
        listClicked(broadList) {
            this.$router.push('/broadcastDetail/' + broadList.id);
            // console.log(broadList.id)
        },
    },
    created() {
        this.getOrders();
    }
}
